import * as html2pdf from 'html2pdf.js';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';
import { MetadataService } from '../../../BaseFramework/core/http/metadata.service';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ArrayManipulations } from 'app/BaseFramework/core/utilities/arrayManipulations';
import { retry } from 'rxjs/operators';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

interface PremiumBreakUpOutput{
  policyType? : string,
  insuredName? : string,
  insuredID? : string,
  insuredGender? : string,
  insuredAge? : number,
  coverageType? : string,
  coverageName? : string,
  sumInsuredAmt? : number,
  premium? : number,
  deductibleAmt?  : number,
  tax?  : number,
  SGST? : number,
  CGST? : number,
  totalPremiumAmt? : number
  finalPremiumAmt? : number
}
@Component({
  selector: 'app-payment-breakup',
  templateUrl: './payment-breakup.component.html',
  styleUrls: ['./payment-breakup.component.scss']
})
export class PaymentBreakupComponent implements OnInit {
  _currentComponentName = "PaymentBreakupComponent"

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    public commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    public lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private arrayManipulations: ArrayManipulations,
    public metadataService: MetadataService) { }

  //Declaraions which might need developer input
  selectorOfThisComponent = 'app-payment-breakup'
  parentEvent$
  environment = environment
  // public LOB = environment['lob'] && environment['lob'].length > 0 ? environment['lob'].find(e => true) : environment['lob'];
  // public LOB = this.appMetadataHandler.allowedLOB && this.appMetadataHandler.allowedLOB.length > 0 ? this.appMetadataHandler.allowedLOB.find(e => true) : this.appMetadataHandler.allowedLOB;
  public LOB = Array.isArray(this.appMetadataHandler.allowedLOB) && this.appMetadataHandler.allowedLOB.length > 0 ? this.appMetadataHandler.allowedLOB.find(e => true) : this.appMetadataHandler.allowedLOB;
  languageCd = this.appMetadataHandler.defaultLanguage

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: string;

  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  get inputDataForEdit() {
    return this._inputDataForEdit;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  ngOnInit() {
    this.getLookups();
    this.subscribeToParentEvent()
    //this.extractLookupData(this.lookup$)
    this.extractPayloadData();

  this.tempTaxObj();

  }

  productCdArr: any = [];
  getLookups() {
    this.lookupDataService.getLookup('productId').subscribe(resp => {
      this.productCdArr = [...resp];
    })
  }

  setProductName(productKey) {
    const result = this.productCdArr.filter(item => item.lookupKey === productKey);
    return result.length > 0 ? result[0].lookupValue : "-";
  }

  //Initializations
  //lookupsToBind = []
  //lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  // lookupData = {}
  // extractLookupData(lookupSubjects) {
  //   for (const key in lookupSubjects) {
  //     lookupSubjects[key].subscribe(resp => {
  //       if (!this.lookupData[key])
  //         this.lookupData[key] = resp
  //     })
  //   }
  // }
  downloadPDF()
  {
    const options = {
      margin: 10,
      filename: "PremiumDetails.pdf",
      image: {type: 'jpeg'},
      html2canvas:{},
      jsPDF:{format: 'a3', orientation: 'landscape'}
    };
    const content: Element= document.getElementById('premiumContent');
    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        // let validationResult = this.validateOutput(this.claimsInsuredCoverageDecisionForm)
        let validationResult = { isInvalid: false } // remove if any customized validations to be added.
        if (!validationResult.isInvalid) {
          let output;
          this.EmitComponentOutput(output)
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }
  
  payloadData;
  insuredPremiumData = [];
  premiumTermYears = [];
  paymentFrequencyCd
  firstYearPremium
  secondYearOnwardsPremium
  extractPayloadData(){
    if(this.inputDataForEdit){
      let DO = this.commonUtilty.getDOName(this.inputDataForEdit);
      this.payloadData = this.inputDataForEdit[DO];
      let term = this.payloadData['policyTerm'] ? Number(this.payloadData['policyTerm']) : 1;
      this.paymentFrequencyCd = this.payloadData['paymentFrequencyCd'] ? this.payloadData['paymentFrequencyCd'] : 'MONTHLY';
      this.premiumTermYears = Array(term).fill(0).map((x,i)=>i+1);
      console.log("input data for life LOB: ", this.inputDataForEdit)
      this.convertPremiumTableSpecificData(DO);
    }
  }

  convertPremiumTableSpecificData(DO){
    let coverageList = DO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages'; 
    if(this.payloadData && this.commonUtilty.isArrayIterable(this.payloadData[coverageList])){
      this.payloadData[coverageList].forEach(coverageData => {
        let insuredList = DO == 'caseDO' ? 'caseCoverageInsureds' : 'proposalCoverageInsureds';
        // if(this.commonUtilty.isArrayIterable(coverageData[insuredList])){
        //   coverageData[insuredList].forEach(insuredData => {

            let coveragePremiumData: PremiumBreakUpOutput = {};
            // let fetchedInsuredData = this.fetchClientData(insuredData.clientRefGuid);
            // if(fetchedInsuredData){
            //   coveragePremiumData['insuredName'] = fetchedInsuredData['name'];
            //   coveragePremiumData['insuredID'] = fetchedInsuredData['clientNum'];
            //   coveragePremiumData['insuredGender'] = fetchedInsuredData['genderCd'];
            //   coveragePremiumData['insuredAge'] = fetchedInsuredData['age'];
            // }

            coveragePremiumData['coverageType'] = coverageData.planTypeCd == "BASEPLAN" ? coverageData.planTypeCd : coverageData.planTypeCd == "RIDER" && coverageData.associationTypeCd == "MANDATORY" ? 'Rider' : 'Add-on';
            coveragePremiumData['coverageName'] = coverageData.productCd || coverageData.planTypeCd;
            coveragePremiumData['sumInsuredAmt'] = coverageData.sumInsuredAmt;
            coveragePremiumData['premium'] = coverageData.baseAnnualPremiumAmt;
            this.firstYearPremium = coverageData.baseAnnualPremiumAmt;
            this.secondYearOnwardsPremium = coverageData.baseAnnualPremiumAmt;
            coveragePremiumData['finalPremiumAmt'] = coverageData.finalPremiumAmt;
            coveragePremiumData['totalUWExtraPremium'] = coverageData.totalUWExtraPremium;
            coveragePremiumData['deductibleAmt'] = coverageData.deductibleAmt

            this.insuredPremiumData.push(coveragePremiumData);

        //   });
        // }


  //       policyType : string,

  //  : string,
  
  // premium : number,
  // discount  : number,
  // tax  : number,
  // SGST : number,
  // CGST : number,

      });
    }
  }

  fetchClientData(clientRefGuid){
    let clientDataFound = {};
    if(clientRefGuid && this.inputDataForEdit && this.commonUtilty.isArrayIterable(this.inputDataForEdit['clientDOs'])){
      clientDataFound = this.inputDataForEdit['clientDOs'].filter(item => item.guid == clientRefGuid);
    }
    return clientDataFound[0];
  }

  UItoServerTransform(payload, response) {
    let componentData = response.componentData
    if (payload && response) {
      //payload['payment'] = this.commonUtilty.deepCopy(componentData)
    }
    return payload
  }

  
  // Front end error list
  errorList: any = [];
  validateOutput(o): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);
    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }
    return validationOutput
  }

  baseCompanyCountryCd = null;
  tempTaxObj(){
    this.metadataService.fetchUserCountry().subscribe(data =>{
      this.baseCompanyCountryCd = data && data.companyMasterDO && data.companyMasterDO.applicableCountryCd ? 
                                  data.companyMasterDO.applicableCountryCd : 'INDIA';
  });
  }

  getTaxComputed(premium){
    return Math.round(5*premium/100)
  }

  getTotalPremiumWithTax(totalPremiumAmt){
    var tax = Math.round(5*totalPremiumAmt/100);
    return totalPremiumAmt + tax;
  }

  getTotalInstallment(premium){
    if (this.paymentFrequencyCd) {
      if (this.paymentFrequencyCd == 'MONTHLY') return Math.round(this.getTotalPremiumWithTax(premium) / 12)
      else if (this.paymentFrequencyCd == 'SEMIANNUAL') return Math.round(this.getTotalPremiumWithTax(premium) / 2)
      else if (this.paymentFrequencyCd == 'QUARTERLY') return Math.round(this.getTotalPremiumWithTax(premium) / 4)
      else if (this.paymentFrequencyCd == 'SINGLE') return Math.round(this.getTotalPremiumWithTax(premium))
      else return Math.round(this.getTotalPremiumWithTax(premium) / 12)
    }
  }

}
